var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-text"},[_c('h1',[_vm._v("Josh Graham")]),_c('h4',[_vm._v("Product Manager")])])
}]

export { render, staticRenderFns }